<template>
  <div class="charts-styles" v-if="chartItems.length">
    <r-simple-card
      v-for="(chartItem, i) in chartItems"
      :key="i"
      :title="chartItem ? chartItem : 'Не выбрано'"
    >
      <div class="tab-pane__content">
        <div class="panel__item panel__slider" v-if="pickerShow.lineWidth">
          <r-slider
            :title="$t('line-width')"
            :min="1"
            :max="10"
            :step="1"
            :number="chartStyles[i].lineWidth"
            @change="e => updateStyle('lineWidth', e, i)"
          />
        </div>
        <div class="panel__item" v-if="pickerShow.border">
          <r-color-picker
            :title="$t('border-color')"
            :color="chartStyles[i].border"
            :color-opacity="0.5"
            @change="e => updateStyle('border', e, i)"
          />
        </div>
        <div class="panel__item panel__color" v-if="pickerShow.background">
          <r-color-picker
            :title="$t('background')"
            :color="chartStyles[i].background"
            :color-opacity="0.5"
            @change="e => updateStyle('background', e, i)"
          />
        </div>
        <div class="panel__item panel__color" v-if="pickerShow.pointBorder">
          <r-color-picker
            :title="$t('point-border')"
            :color="chartStyles[i].pointBorder"
            :color-opacity="0.5"
            @change="e => updateStyle('pointBorder', e, i)"
          />
        </div>
        <div class="panel__item panel__color" v-if="pickerShow.point">
          <r-color-picker
            :title="$t('point')"
            :color="chartStyles[i].point"
            :color-opacity="0.5"
            @change="e => updateStyle('point', e, i)"
          />
        </div>
      </div>
    </r-simple-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      chartId: null,
      chartType: "",
      chartItems: [],
      chartStyles: [],
      pickerShow: {
        lineWidth: false,
        border: false,
        background: false,
        point: false,
        pointBorder: false
      }
    };
  },
  watch: {
    "$store.state.charts.activeChart": {
      handler: function(value) {
        this.chartItems = [];
        this.chartId = Object.keys(value)[0];
        const chartData = this.$store.state.charts.chartsData[this.chartId];
        const openedChart = this.$store.state.charts.openedCharts[this.chartId];
        if (chartData) {
          this.chartType = value[this.chartId].type;
          this.changePickerShow();
          chartData.data.forEach(e => {
            this.chartItems.push(e.dataTitle);
          });
          if (openedChart.styles && openedChart.styles.length) {
            this.chartStyles = openedChart.styles;
          }
        } else {
          this.chartItems = [];
        }
        if (this.$store.state.charts.activeChart.updated) {
          this.$store.state.charts.activeChart.updated = false;
        }
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    updateStyle(propName, val, i) {
      const value = propName === "lineWidth" ? val : val.color;

      this.chartStyles[i][propName] = value;
      this.$store.commit("SET_CHART_STYLE_CONFIG", {
        id: this.chartId,
        propName,
        value,
        i
      });
    },
    changePickerShow() {
      switch (this.chartType) {
        case "basic":
          this.pickerShow.lineWidth = true;
          this.pickerShow.border = true;
          this.pickerShow.background = true;
          this.pickerShow.point = true;
          this.pickerShow.pointBorder = true;
          break;
        case "polar":
          this.pickerShow.lineWidth = true;
          this.pickerShow.border = true;
          this.pickerShow.background = false;
          this.pickerShow.point = false;
          this.pickerShow.pointBorder = true;
          break;
        case "bar":
        case "pie":
        case "doughnut":
        case "bar-x":
        case "pie-rose":
        case "scatter":
          this.pickerShow.lineWidth = false;
          this.pickerShow.border = false;
          this.pickerShow.background = true;
          this.pickerShow.point = false;
          this.pickerShow.pointBorder = false;
          break;
        default:
          break;
      }
    }
  }
};
</script>

<style lang="scss">
.charts-styles {
  overflow: hidden;
  .panel__item {
    margin-top: 12px;
    &:first-child {
      margin-top: 0;
    }
  }
  .el-collapse-item {
    margin-bottom: 8px;
    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "line-width": "Толщина линии",
    "border-color": "Обводка секций",
    "background": "Заливка секций",
    "point": "Заливка точки",
    "point-border": "Обводка точки"
  },
  "en": {
    "line-width": "Line width",
    "border-color": "Border color",
    "background": "Background color",
    "point": "Point color",
    "point-border": "Point border color"
  }
}
</i18n>
